export default "__VITE_ASSET__Do4leMzS__"